var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"custom-button-1",on:{"click":_vm.toggleLang}},[_vm._v(_vm._s(_vm._f("upper")(_vm.lang)))])}
var staticRenderFns = []

export { render, staticRenderFns }